/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FeedbackBaseParser = /* #__PURE__ */ parsers.object([]);
export class FeedbackBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FeedbackBaseParser.decode(input).map(res => new FeedbackBase(res));
    }
    static unsafeDecode(input) {
        return FeedbackBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FeedbackBaseParser.encode(data);
    }
    static schema() {
        return FeedbackBaseParser.schema();
    }
}
